import DashIcon from './component.jsx'
export default DashIcon
